import { CountryCodes } from 'src/Libs/flow/constants/countries'
import { GoogleAddressComponent, GoogleMapsGeometry, UserLocationData } from '../types/location.types'

export const countryCodesMap: Record<string, CountryCodes> = {
  DE: 'DEU',
  FR: 'FRA',
  CH: 'CHE',
  NL: 'NLD',
  IT: 'ITA',
  PL: 'POL',
  PT: 'PRT',
  ES: 'ESP',
  SE: 'SWE',
  CZ: 'CZE',
  AT: 'AUT',
  ZA: 'ZAF',
  LU: 'LUX',
  BA: 'BIH',
  HR: 'HRV',
  DK: 'DNK',
  BE: 'BEL',
} as const

export const getLocationDetails = (addressComponents: GoogleAddressComponent[], geometry: GoogleMapsGeometry): UserLocationData => {
  const userLocationData: UserLocationData = {
    city: '',
    houseNumber: '',
    postalCode: '',
    street: '',
    countryCode: '',
    coordinates: {
      lat: geometry.location.lat,
      lng: geometry.location.lng,
    },
  }

  addressComponents.forEach(currentAddressComponent => {
    const addressTypes = currentAddressComponent.types
    const addressValue = currentAddressComponent.long_name
    if (addressTypes.includes('route')) userLocationData.street = addressValue
    if (addressTypes.includes('street_number')) userLocationData.houseNumber = addressValue
    if (addressTypes.includes('locality')) userLocationData.city = addressValue
    if (addressTypes.includes('country'))
      userLocationData.countryCode = countryCodesMap[currentAddressComponent.short_name as keyof typeof countryCodesMap]
    if (addressTypes.includes('postal_code')) userLocationData.postalCode = addressValue
  })

  return userLocationData
}
